module.exports = __webpack_public_path__ + "img/busca-avancada-ornamentales.ac77d1a9.jpg";